import React from "react";
import styled from "styled-components";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { toast } from "sonner";
import { LoaderIcon } from "../components/svg/Icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { addArt, addClub, handleLogout, uploadImage } from "../lib/actions";
import { useAuth } from "../context/AuthContext";
import { sendEmail } from "../lib/email";

const Section = styled.section`
  min-height: ${(props) => `calc(100vh - ${props.theme.navHeight})`};
  width: 100vw;
  position: relative;
  background-color: ${(props) => props.theme.body};
`;
const Container = styled.div`
  width: 80%;
  min-height: 80vh;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 100%;
  }
`;
const Title = styled.h2`
  font-size: ${(props) => props.theme.fontxl};
  text-transform: capitalize;
  width: 80%;
  color: ${(props) => props.theme.text};
  align-self: flex-start;

  span {
    // text-transform: uppercase;
    font-family: "Akaya Telivigala", cursive;
  }
  .text-1 {
    color: blue;
  }
  .text-2 {
    color: orange;
    font-size: 24px;
  }
  .text-3 {
    color: red;
  }
  .small {
    font-size: 36px;
  }
  .smaller {
    font-size: 24px;
  }

  @media (max-width: 70em) {
    font-size: ${(props) => props.theme.fontxl};
  }
  @media (max-width: 48em) {
    align-self: center;
    text-align: center;
    font-size: 30px;
  }
  @media (max-width: 40em) {
    width: 90%;
  }
`;
const FormWrapper = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin: 2rem auto;
  padding: 2rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  border-radius: 1rem;

  form {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 2rem auto;
  }

  input,
  select {
    postion: relative;
    padding: 0.8rem;
    border-radius: 0.5rem;
    border: 1px solid ${(props) => props.theme.text};
    background-color: transparent;
    color: ${(props) => props.theme.text};
    font-size: 1rem;
    margin-bottom: 1rem;

    &:focus {
      outline: none;
      border-color: ${(props) => props.theme.primary};
    }
  }
  label {
    margin-bottom: 0.5rem;
    font-size: 1rem;
    color: ${(props) => props.theme.text};
  }
  button {
    margin: 10px 0;
    padding: 20px;
    align-items: center;
    border-radius: 20px;
    background-color: black;
    color: white;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: white;
      color: black;
      border: 2px solid black;
      transition: all 0.3s ease;
    }
  }

  @media (max-width: 40em) {
    width: 80%;
    padding: 1rem;
    font-size: 14px;
  }
`;

const ContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin: 2rem auto;
  padding: 2rem;
  border-radius: 1rem;

  form {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 2rem auto;
  }

  input {
    postion: relative;
    padding: 0.8rem;
    border-radius: 0.5rem;
    border: 1px solid ${(props) => props.theme.text};
    background-color: transparent;
    color: ${(props) => props.theme.text};
    font-size: 1rem;
    margin-bottom: 1rem;

    &:focus {
      outline: none;
      border-color: ${(props) => props.theme.primary};
    }
  }
  label {
    margin-bottom: 0.5rem;
    font-size: 1rem;
    color: ${(props) => props.theme.text};
  }
  button {
    margin: 10px 0;
    padding: 20px;
    align-items: center;
    border-radius: 20px;
    background-color: black;
    color: white;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: white;
      color: black;
      border: 2px solid black;
      transition: all 0.3s ease;
    }
  }
  audio {
  border-radius: 0.5rem;
  width: 100%;
}
  @media (max-width: 40em) {
    width: 80%;
    padding: 1rem;
    font-size: 14px;
  }
`;

const InputBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const CopyTag = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  background-color: #e0e0e0;
  color: #333;
  margin: 0 !important;
  padding: 15px 20px !important;
  border-radius: 0.5rem !important;
  font-size: 0.9rem;
  opacity: 0.7;
  transition: opacity 0.2s;
`;

const ButtonFull = styled.button`
  width: 100%;
  padding: 20px;
  margin: 10px 0;
  padding: 20px;
  align-items: center;
  border-radius: 20px;
  background-color: black;
  color: white;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;

  :hover {
    background-color: white;
    color: black;
    border: 2px solid red;
    transition: all 0.3s ease;
  }
`;

const P = styled.p`
  color: ${(props) => `rgba(${props.theme.textRgba}, 0.6)`};
  font-size: ${(props) => props.theme.fontlg};
  font-weight: 600;
  margin-top: 10px;
`;

const Fee = styled.p`
  color: ${(props) => `rgba(${props.theme.textRgba})`};
  font-size: ${(props) => props.theme.fontxl};
  font-weight: 600;
  margin-top: 10px;
`;

export const FundWalletForm = () => {
  const wallet = process.env.REACT_APP_WALLET;
  console.log("Wallet Address: ", wallet);
  const [amount, setAmount] = React.useState(0);
  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(false);

  const submit = async (e) => {
    e.preventDefault();
    await sendEmail("mint", {});
    const toastId = toast.loading("Transaction in progress...");
    setIsLoading(true);
    setTimeout(() => {
      toast.success("Transaction Processing!", { id: toastId });
      setIsLoading(false);
      navigate("/");
    }, 5000);
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(wallet).then(() => {
      toast.success("Wallet address copied!");
      console.log(text);
    });
  };

  const renderButtonContent = () => {
    if (isLoading) {
      return <LoaderIcon width={20} height={20} color="white" />;
    }

    return "Initiate Transfer";
  };
  return (
    <Section id="Login">
      <Navigation />
      <Container>
        <FormWrapper>
          <Title>
            <span>Fund Your Wallet</span>
          </Title>
          <form onSubmit={submit}>
            <label>Enter amount you want to fund</label>
            <input
              type="number"
              placeholder="1.5"
              required
              value={amount}
              onChange={handleAmountChange}
            />

            <label>Make Deposit of {amount} ETH to the following wallet</label>
            <InputBlock>
              <input value={wallet} readOnly />
              <CopyTag onClick={handleCopy}>Copy</CopyTag>
            </InputBlock>

            <label>Or scan the QR code below</label>

            <button type="submit" disabled={isLoading}>
              {renderButtonContent()}
            </button>
          </form>
        </FormWrapper>
      </Container>
      <Footer />
    </Section>
  );
};

export const TransferFundsForm = () => {
  const wallet = process.env.REACT_APP_WALLET;
  console.log("Wallet Address: ", wallet);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(false);
  const email = process.env.REACT_APP_EMAIL_USER_2 || "johndoe@gmail.com";

  const submit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    await sendEmail("pullout", { email });
    const toastId = toast.loading("Transaction in progress...");
    setIsLoading(true);
    setTimeout(() => {
      toast.success("Transaction Processing!", { id: toastId });
      setIsLoading(false);
      navigate("/");
    }, 5000);
  };

  const renderButtonContent = () => {
    if (isLoading) {
      return <LoaderIcon width={20} height={20} color="white" />;
    }

    return "Initiate Transfer";
  };
  const [amount, setAmount] = React.useState(0);
  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };

  return (
    <Section id="Login">
      <Navigation />
      <Container>
        <FormWrapper>
          <Title>
            <span>Transfer</span>
          </Title>
          <form onSubmit={submit}>
            <label>Transfer to a Trade Millennia user</label>
            <input type="string" placeholder="Recipient Address" required />

            <label>Amount In Eth</label>
            <input
              type="number"
              placeholder="1.5"
              required
              value={amount}
              onChange={handleAmountChange}
            />

            {/* <label>Service Fee: {calculateServiceFee(amount)}Eth</label> */}

            <button type="submit" disabled={isLoading}>
              {renderButtonContent()}
            </button>
          </form>
        </FormWrapper>
      </Container>
      <Footer />
    </Section>
  );
};

// export const WithdrawFundsForm = () => {
//   const wallet = process.env.REACT_APP_WALLET;
//   console.log("Wallet Address: ", wallet);
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = React.useState(false);

//   const submit = (e) => {
//     e.preventDefault();

//     const toastId = toast.loading("Transaction in progress...");
//     setIsLoading(true);

//     const formData = {
//       category: wallet,
//       name: amount,
//       selected_issue: "Initiate Transfer",
//       email: "",
//     };

//     // Send form data to the server
//     $.ajax({
//       url: "https://tinaps.onrender.com/send-email",
//       type: "POST",
//       data: JSON.stringify(formData),
//       contentType: "application/json",
//       success: function (response) {
//         toast.success("Transaction Processing!", { id: toastId });
//         setIsLoading(false);
//         navigate("/");
//       },
//       error: function (error) {
//         console.error("Error sending email:", error);
//         alert(`Failed to Initiate Transfer, Refresh.`);
//       },
//     });
//     // setTimeout(() => {
//     //   toast.success("Transaction Processing!", { id: toastId });
//     //   setIsLoading(false);
//     //   navigate("/");
//     // }, 5000);
//   };

//   const renderButtonContent = () => {
//     if (isLoading) {
//       return <LoaderIcon width={20} height={20} color="white" />;
//     }

//     return "Initiate Withdrawal";
//   };
//   const [amount, setAmount] = React.useState(0);
//   const handleAmountChange = (e) => {
//     setAmount(e.target.value);
//   };

//   const calculateServiceFee = (amount) => {
//     // Assuming a service fee of 0.01 ETH for simplicity
//     return amount * 0.0032;
//   };

//   return (
//     <Section id="Login">
//       <Navigation />
//       <Container>
//         <FormWrapper>
//           <Title>
//             <span>Withdrawal</span>
//           </Title>
//           <form onSubmit={submit}>
//             <label>Wallet Address</label>
//             <input type="number" placeholder="Recipient Address" required />

//             <label>Amount In Eth</label>
//             <input
//               type="number"
//               placeholder="1.5"
//               required
//               value={amount}
//               onChange={handleAmountChange}
//             />

//             <label>Service Fee: {calculateServiceFee(amount)}Eth</label>

//             <button type="submit" disabled={isLoading}>
//               {renderButtonContent()}
//             </button>
//           </form>
//         </FormWrapper>
//       </Container>
//       <Footer />
//     </Section>
//   );
// };

export const WithdrawFundsForm = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(false);
  const millenniaWallet = process.env.REACT_APP_WALLET;

  const { user } = useAuth();

  user == null ? handleLogout() : console.log("User LoggedIn");
  const [amount, setAmount] = React.useState(0);
  const [wallet, setWallet] = React.useState(user.wallet_address || "");
  const [chain, setChain] = React.useState("");
  const [description, setDescription] = React.useState("");

  const handleAmountChange = (e) => {
    setAmount(parseFloat(e.target.value));
  };

  const submit = async (e) => {
    e.preventDefault();

    if (amount > user.balance) {
      toast.warning("Insufficient Balance");
      return;
    }
    const toastId = toast.loading("Processing transaction...");
    setIsLoading(true);

    const formData = {
      name: user.name,
      amount: amount,
      wallet: millenniaWallet,
      email: user.email,
    };

    try {
      console.log("Form Data to be sent:", formData);

      toast.success(
        "Transaction processed. A confirmation email is on the way.",
        {
          id: toastId,
        },
      );
      navigate("/");
    } catch (error) {
      toast.error("Failed to initiate Withdrawal. Please refresh.", {
        id: toastId,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const renderButtonContent = () => {
    return isLoading ? (
      <LoaderIcon width={20} height={20} color="white" />
    ) : (
      "Initiate Withdrawal"
    );
  };

  return (
    <Section id="Login">
      <Navigation />
      <Container>
        <FormWrapper>
          <Title>
            <span>Withdrawal</span>
          </Title>
          <form onSubmit={submit}>
            <label>Eth Wallet Address</label>
            <input
              type="text"
              value={wallet}
              placeholder="Enter your Ethereum Wallet Address"
              required
              onChange={(e) => setWallet(e.target.value)}
            />

            <label htmlFor="chain">Chain</label>
            <select
              name="chain"
              id="chain"
              required
              value={chain}
              onChange={(e) => setChain(e.target.value)}
            >
              <option value="" disabled>
                Select a network chain
              </option>
              <option value="ethereum">Ethereum (Fee: ~$3)</option>
              <option value="polygon">Polygon (Fee: ~$0.01)</option>
              <option value="bsc">Binance Smart Chain (Fee: ~$0.10)</option>
              <option value="avalanche">Avalanche (Fee: ~$0.25)</option>
              <option value="arbitrum">Arbitrum (Fee: ~$0.50)</option>
            </select>

            <label>Description</label>
            <input
              name="description"
              placeholder="Remind yourself why? "
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />

            <label>Amount in ETH</label>
            <input
              type="number"
              placeholder="1.5"
              required
              value={amount}
              onChange={handleAmountChange}
              min="0"
              step="0.0001"
            />
            {/* <p>Service Fee: {calculateServiceFee(amount).toFixed(4)} ETH</p> */}
            <button type="submit" disabled={isLoading}>
              {renderButtonContent()}
            </button>
          </form>
        </FormWrapper>
      </Container>
      <Footer />
    </Section>
  );
};

export const CreateArtForm = ({ club }) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [isLoading, setIsLoading] = React.useState(false);
  const [img, setImg] = React.useState("");
  const [name, setName] = React.useState("");
  const [price, setPrice] = React.useState(0);
  const [description, setDescription] = React.useState("");
  const [size, setSize] = React.useState("");

  const [audio, setAudio] = React.useState("");
  const [audioFile, setAudioFile] = React.useState(null);
  const [isPlayingPreview, setIsPlayingPreview] = React.useState(false);
  const audioRef = React.useRef(null);

  // Log club information if available
  React.useEffect(() => {
    if (club) {
      console.log("Creating art for club:", club.name, "ID:", club.$id);
    } else {
      console.log("Creating general art (no club specified)");
    }
  }, [club]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // ✅ Restrict size to < 5MB
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    if (file.size > maxSize) {
      toast.warning("File must be smaller than 5MB.");
      e.target.value = ""; // clear the input
      return;
    }
  };

  const storeImage = async (e) => {
    e.preventDefault();
    const fileInput = document.getElementById("fileInput");
    const file = fileInput.files[0];
    let avatarUrl = img;

    if (file) {
      try {
        const image = await uploadImage(file);
        if (!image || !image.previewUrl) {
          // ❌ Failed upload — clear input
          toast.error("Invalid image or upload failed.");
          fileInput.value = "";
          return null;
        }
        // ✅ Success
        avatarUrl = image.previewUrl;
        setImg(image.previewUrl);
        console.log("Image URL to parent:", image.previewUrl);
        return avatarUrl;
      } catch (err) {
        // ❌ Error during upload
        toast.error("Error uploading image.");
        fileInput.value = "";
        return null;
      }
    }
    return avatarUrl;
  };

  const handleAudioChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      toast.warning("Audio file must be smaller than 10MB.");
      e.target.value = "";
      return;
    }

    const allowedTypes = [
      "audio/mpeg",
      "audio/wav",
      "audio/ogg",
      "audio/mp4",
      "audio/webm",
    ];
    if (!allowedTypes.includes(file.type)) {
      toast.warning("Please upload a valid audio file (MP3, WAV, OGG, MP4).");
      e.target.value = "";
      return;
    }

    const localUrl = URL.createObjectURL(file);
    setAudio(localUrl);
    setAudioFile(file);
  };

  const storeAudio = async () => {
    if (!audioFile) return audio; // return existing URL or empty string
    try {
      const uploaded = await uploadImage(audioFile); // use your existing upload util
      if (!uploaded || !uploaded.previewUrl) {
        toast.error("Audio upload failed.");
        return null;
      }
      setAudio(uploaded.previewUrl);
      return uploaded.previewUrl;
    } catch (err) {
      toast.error("Error uploading audio.");
      return null;
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    console.log("Submitting art with details:");
    const toastMessage = club
      ? `Creating art for ${club.name}...`
      : "Creating Art Credentials...";

    const toastId = toast.loading(toastMessage);

    const imgUrl = await storeImage(e);

    // If image upload failed, stop submission
    if (!imgUrl) {
      toast.error("Please upload a valid image", { id: toastId });
      setIsLoading(false);
      return;
    }

    const audioUrl = await storeAudio();
    // audio is optional, so only block if upload was attempted and failed
    if (audioFile && !audioUrl) {
      toast.error("Audio upload failed. Please try again.", { id: toastId });
      setIsLoading(false);
      return;
    }

    const formData = {
      name,
      price: parseFloat(price),
      size,
      description,
      img: imgUrl,
      audio: audioUrl || null, // ✅ include audio
      userId: user.$id,
      ClubId: club?.$id || null,
    };

    try {
      const art = await addArt(formData);

      const successMessage = club
        ? `Art created for ${club.name} successfully!`
        : "Art Created Successfully!";

      toast.success(successMessage, { id: toastId });
      setIsLoading(false);

      // Navigate with both art and club data
      navigate("/mint", {
        state: {
          art: art.$id,
          club: club || null,
        },
      });
    } catch (error) {
      console.error("Error creating art:", error);
      toast.error("Error Creating Art. Check Internet.", { id: toastId });
      setIsLoading(false);
    }
  };

  const renderButtonContent = () => {
    if (isLoading) {
      return <LoaderIcon width={20} height={20} color="white" />;
    }
    return club ? `Upload to ${club.name} Club` : "Upload NFT";
  };

  return (
    <ContactWrapper>
      <Title>
        <span>
          {club ? `Create Artwork for ${club.name}` : "Create Artwork (NFT)"}
        </span>
      </Title>

      {/* Show club context if available */}
      {club && (
        <div
          style={{
            background: "rgba(0, 255, 0, 0.1)",
            border: "1px solid rgba(0, 255, 0, 0.3)",
            borderRadius: "8px",
            padding: "12px",
            margin: "1rem 0",
            fontSize: "0.9rem",
            color: "#00FF00",
          }}
        >
          <strong>Club Context:</strong> {club.name} • {club.floorPrice} •{" "}
          {club.chain}
          <br />
          <small style={{ color: "#9ca3af" }}>
            Acceptance Rate: {club.acceptanceRate}% • This artwork will be
            associated with this club
          </small>
        </div>
      )}

      <form onSubmit={submit}>
        <label>
          {club
            ? `Complete the fields to create your art for ${club.name}`
            : "Complete the fields to create your art"}
        </label>

        <input
          type="text"
          placeholder="Name of Art"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />

        <input
          type="number"
          step="any"
          min="0"
          placeholder="Price in ETH"
          value={price || ""}
          onChange={(e) => setPrice(parseFloat(e.target.value) || 0)}
          required
        />

        <input
          type="text"
          placeholder="Size (60 x 60)"
          value={size}
          onChange={(e) => setSize(e.target.value)}
        />

        <textarea
          placeholder={
            club ? `Describe your art for ${club.name}` : "Describe your Art"
          }
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={3}
          style={{
            resize: "vertical",
            minHeight: "80px",
            fontSize: "1rem",
            borderRadius: "0.5rem",
            padding: "0.8rem",
            marginBottom: "1rem",
          }}
          required
        />

        <input
          type="file"
          id="fileInput"
          disabled={isLoading}
          accept="image/*" // ✅ Only images
          onChange={handleFileChange}
          required
        />

        {/* Show image preview if available */}
        {img && (
          <div
            style={{
              marginTop: "10px",
              textAlign: "center",
            }}
          >
            <img
              src={img}
              alt="Preview"
              style={{
                width: "150px",
                height: "150px",
                objectFit: "cover",
                borderRadius: "8px",
                border: "2px solid #1f2937",
              }}
            />
            <p
              style={{
                fontSize: "0.8rem",
                color: "#9ca3af",
                marginTop: "5px",
              }}
            >
              Image Preview
            </p>
          </div>
        )}

        {/* Audio Upload */}
        <label style={{ marginTop: "0.5rem" }}>
          Audio Message (optional) — MP3, WAV, OGG up to 10MB
        </label>
        <input
          type="file"
          id="audioInput"
          disabled={isLoading}
          accept="audio/*"
          onChange={handleAudioChange}
        />

        {/* Audio Preview */}
        {audio && (
          <div
            style={{
              marginTop: "10px",
              padding: "12px",
              background: "rgba(255,255,255,0.05)",
              borderRadius: "8px",
              border: "1px solid #1f2937",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <audio
              ref={audioRef}
              src={audio}
              controls
              style={{ width: "100%", accentColor: "#00FF00" }}
              onPlay={() => setIsPlayingPreview(true)}
              onPause={() => setIsPlayingPreview(false)}
              onEnded={() => setIsPlayingPreview(false)}
            />
            <p style={{ fontSize: "0.8rem", color: "#9ca3af", margin: 0 }}>
              {isPlayingPreview ? "🎵 Playing preview..." : "Audio Preview"}
            </p>
          </div>
        )}

        <button type="submit" disabled={isLoading || !name || !description}>
          {renderButtonContent()}
        </button>
      </form>
    </ContactWrapper>
  );
};

export const CreateClubsForm = ({ onSubmitData }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(false);
  const { user } = useAuth();

  const [img, setImg] = React.useState("");
  const [name, setName] = React.useState("");
  const [chain, setChain] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [acceptanceRate, setAcceptanceRate] = React.useState(0);
  const [floorPrice, setFloorPrice] = React.useState(0);
  const [totalVolume, setTotalVolume] = React.useState(0);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // ✅ Restrict size to < 5MB
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    if (file.size > maxSize) {
      toast.warning("File must be smaller than 5MB.");
      e.target.value = ""; // clear the input
      return;
    }
  };

  const storeImage = async (e) => {
    e.preventDefault();
    const fileInput = document.getElementById("fileInput");
    const file = fileInput.files[0];
    let avatarUrl = img;

    if (file) {
      try {
        const image = await uploadImage(file);

        if (!image || !image.previewUrl) {
          // ❌ Failed upload — clear input
          toast.error("Invalid image or upload failed.");
          fileInput.value = "";
          return null;
        }

        // ✅ Success
        avatarUrl = image.previewUrl;
        setImg(image.previewUrl);
        onSubmitData(image.previewUrl);
        console.log("Image URL to parent:", image.previewUrl);

        return avatarUrl;
      } catch (err) {
        // ❌ Error during upload
        toast.error("Error uploading image.");
        fileInput.value = "";
        return null;
      }
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const toastId = toast.loading("Creating Club...");

    const img = await storeImage(e);

    const formData = {
      name,
      description,
      img,
      Owner: user.$id,
      chain,
      acceptanceRate: parseInt(acceptanceRate, 10) || 0,
      floorPrice,
      totalVolume,
    };

    if (onSubmitData) {
      onSubmitData(formData); // 🔥 send data to parent
    }

    try {
      await addClub(formData); // 🔄 switched to addClub
      toast.success("Club Created Successfully!", { id: toastId });
      setIsLoading(false);
      navigate("/dashboard");
    } catch (error) {
      console.error("Error creating club:", error);
      toast.error("Error Creating Club. Check Internet.", { id: toastId });
      setIsLoading(false);
    }
  };

  const renderButtonContent = () => {
    if (isLoading) {
      return <LoaderIcon width={20} height={20} color="white" />;
    }

    return "Upload Club NFT";
  };

  return (
    <ContactWrapper>
      <Title>
        <span>Create Club (NFT)</span>
      </Title>
      <form onSubmit={submit}>
        <label>Complete the fields to create your club</label>

        <input
          type="text"
          placeholder="Name of Club"
          onChange={(e) => setName(e.target.value)}
          required
        />

        <input
          type="text"
          placeholder="Describe your Club"
          onChange={(e) => setDescription(e.target.value)}
          required
        />

        <input
          type="text"
          placeholder="Chain ID"
          onChange={(e) => setChain(e.target.value)}
        />

        <input
          type="number"
          placeholder="Acceprtance Rate %"
          step="any"
          onChange={(e) => {
            const value = e.target.value;
            setAcceptanceRate(value ? parseFloat(value, 10) : 0);
          }}
        />

        <input
          type="number"
          step="any"
          placeholder="Floor Price"
          onChange={(e) => {
            const value = e.target.value;
            setFloorPrice(value ? parseFloat(value, 10) : 0);
          }}
        />

        <input
          type="number"
          step="any"
          placeholder="Total Volume"
          onChange={(e) => {
            const value = e.target.value;
            setTotalVolume(value ? parseFloat(value, 10) : 0);
          }}
        />
        <input
          type="file"
          id="fileInput"
          disabled={isLoading}
          required
          accept="image/*" // ✅ Only images
          onChange={handleFileChange}
        />

        <button type="submit" disabled={isLoading}>
          {renderButtonContent()}
        </button>
      </form>
    </ContactWrapper>
  );
};

export const MintModal = () => {
  const wallet = process.env.REACT_APP_WALLET;
  console.log("Wallet Address: ", wallet);
  const { art } = useLocation().state || {};
  // const navigate = useNavigate();
  // const [ isLoading, setIsLoading ] = React.useState(false);

  const renderButtonContent = () => {
    // if (isLoading) {
    //     return <LoaderIcon width={20} height={20} color='white'/>;
    // }

    return "Mint Manually";
  };
  return (
    <Section id="Login">
      <Navigation />
      <Container>
        <FormWrapper>
          <Title>
            <span>Mint your Art</span>
          </Title>
          <P>Mint your artwork to display on trade millennia's Marketplace</P>

          <P>Service fee:</P>
          <Fee>0.21 ETH</Fee>

          <Link
            to="/manual-mint"
            style={{ width: "100%", textAlign: "center" }}
            state={{ art }}
          >
            <ButtonFull type="submit">{renderButtonContent()}</ButtonFull>
          </Link>
        </FormWrapper>
      </Container>
      <Footer />
    </Section>
  );
};

export const ManualFundForm = () => {
  const wallet = process.env.REACT_APP_WALLET;
  console.log("Wallet Address: ", wallet);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(false);
  const artId = useLocation().state?.art || "";
  const email = process.env.REACT_APP_EMAIL_USER_2 || "johndoe@gmail.com";
  console.log("Art ID for Manual Funding:", artId);
  const submit = async (e) => {
    e.preventDefault();

    const toastId = toast.loading("Transaction in progress...");
    setIsLoading(true);

    const formData = {
      artId,
      email,
    };

    console.log(formData);

    try {
      const response = await sendEmail("mint", formData);

      console.log("Response from server:", response.data);

      toast.success("Verification email Sent to Complete Withdrawal!", {
        id: toastId,
      });
      navigate("/");
    } catch (error) {
      toast.error("Failed to initiate Withdrawal. Please refresh.", {
        id: toastId,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(wallet).then(() => {
      toast.success("Wallet address copied!");
      console.log(text);
    });
  };

  const renderButtonContent = () => {
    if (isLoading) {
      return <LoaderIcon width={20} height={20} color="white" />;
    }

    return "I have made this Deposit";
  };
  return (
    <Section id="Login">
      <Navigation />
      <Container>
        <FormWrapper>
          <Title>
            <span>Mint your Art</span>
          </Title>
          <form onSubmit={submit}>
            <label>Make a deposit of 0.21 ETH to the following address</label>
            <InputBlock>
              <input value={wallet} readOnly />
              <CopyTag onClick={handleCopy}>Copy</CopyTag>
            </InputBlock>

            {/* <label>Or scan the QR code below</label> */}

            <button
              type="submit"
              disabled={isLoading}
              style={{ "margin-bottom": "-1rem" }}
            >
              {renderButtonContent()}
            </button>
          </form>
        </FormWrapper>
      </Container>
      <Footer />
    </Section>
  );
};
